import { useAdAccountStore, useIntegrationsStore } from 'stores';
import { BrandIntegrationStatus, IntegrationType } from 'types/integrations';
import { IntegrationStatus } from 'types/stores/integration-store';

const useFacebook = () => {
  const adAccountStore = useAdAccountStore();
  const integrationsStore = useIntegrationsStore();

  // TODO -- there is only one FB integration per brand now, so this logic could be simplified
  const getMetaStatus = () => {
    const fbIntegrations = integrationsStore.getAllIntegrations({ type: IntegrationType.Facebook });
    const neverConnected = fbIntegrations.length === 0;

    if (neverConnected) return BrandIntegrationStatus.NeverConnected;

    const hasActiveFBIntegration = fbIntegrations.some(
      integration => integration.status === IntegrationStatus.Active
    );

    const hasAdAccount = adAccountStore.metaAdAccount?.adAccountId;
    const isConnected = hasActiveFBIntegration && hasAdAccount;
    const isIncomplete = hasActiveFBIntegration && !hasAdAccount;

    if (isConnected) {
      return BrandIntegrationStatus.Connected;
    }

    if (isIncomplete) return BrandIntegrationStatus.Incomplete;

    return BrandIntegrationStatus.Disconnected;
  };

  return {
    getMetaStatus
  };
};

export default useFacebook;
